import { appManagementStrings } from '../i18n';

export const UI_ROLE_TYPE = {
  NONE: appManagementStrings.roleTypes.none,
  READER: appManagementStrings.roleTypes.reader,
  CONTRIBUTOR: appManagementStrings.roleTypes.contributor,
  EDITOR: appManagementStrings.roleTypes.editor,
  ADMINISTRATOR: appManagementStrings.roleTypes.administrator,
} as const;

export const RoleTypes = {
  Administrator: 'ADMINISTRATOR',
  Contributor: 'CONTRIBUTOR',
  Editor: 'EDITOR',
  Reader: 'READER',
} as const;

export type EmptyRole = 'none';
export type RoleType = (typeof RoleTypes)[keyof typeof RoleTypes];
export type UiRoleType = RoleType | EmptyRole;
